import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-[#0F172A] text-slate-300 mt-24" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid md:grid-cols-4 gap-10">
        <div>
          <img
            src="/brand/footer-logo.png"
            alt="SELLEXR — Connect · Manage · Grow"
            className="block h-auto w-[220px] max-w-full rounded-md"
            width="906"
            height="358"
            draggable={false}
            data-testid="footer-logo"
          />
          <p className="mt-4 text-sm text-slate-400 leading-relaxed">
            An e-commerce workforce platform connecting shopkeepers with trained freelancers to grow online sales.
          </p>
        </div>
        <div>
          <div className="font-heading font-semibold text-white mb-4">Platform</div>
          <ul className="space-y-2 text-sm">
            <li><a href="/#features" className="hover:text-white">Features</a></li>
            <li><a href="/#how" className="hover:text-white">How it works</a></li>
            <li><Link to="/academy" className="hover:text-white">Academy</Link></li>
            <li><a href="/#faq" className="hover:text-white">FAQ</a></li>
          </ul>
        </div>
        <div>
          <div className="font-heading font-semibold text-white mb-4">Marketplaces</div>
          <ul className="space-y-2 text-sm">
            <li>Amazon</li><li>Flipkart</li><li>Meesho</li><li>JioMart</li><li>Ajio</li>
          </ul>
        </div>
        <div>
          <div className="font-heading font-semibold text-white mb-4">Company</div>
          <ul className="space-y-2 text-sm">
            <li><a href="/#contact" className="hover:text-white">Contact</a></li>
            <li><Link to="/signup" className="hover:text-white">Become a freelancer</Link></li>
            <li><Link to="/signup" className="hover:text-white">Hire freelancers</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 flex flex-col md:flex-row items-center justify-between text-sm text-slate-500">
          <div>© 2026 SELLEXR. All rights reserved.</div>
          <div className="flex gap-6">
            <Link to="/privacy" data-testid="footer-privacy" className="hover:text-white">Privacy</Link>
            <Link to="/terms" data-testid="footer-terms" className="hover:text-white">Terms</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
